<div class="error-box">
    <div class="error-body text-center">
        <h1 class="error-title text-danger">ERROR</h1>
        <h3 class="text-uppercase error-subtitle">NO PUDIMOS CARGAR LA ENCUESTA</h3>
        <p class="text-muted mt-4 mb-4">
            Lo sentimos, pero la encuesta a la que querés acceder no se pudo cargar
        </p>
        <p class="text-muted mt-4 mb-4">
            Verificá que el link es correcto o que la encuesta no haya finalizado. De lo contrario, comunicate con la universidad
        </p>
        <div class="loader"></div>
    </div>
</div>